export const gtc = function (params) {
    //console.log('DataLayer', params);

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(params)
}

export const scrollToTop = function () {
    var c = document.documentElement.scrollTop || document.body.scrollTop
    if (c > 0) {
        window.requestAnimationFrame(scrollToTop)
        window.scrollTo(0, c - c / 10)
    }
}

export function debounce (func, wait, immediate) {
    var timeout
    return function () {
        var context = this
        var args = arguments
        var callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(function () {
            timeout = null
            if (!immediate) {
                func.apply(context, args)
            }
        }, wait)
        if (callNow) func.apply(context, args)
    }
}

export const urlB64ToUint8Array = function (base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const getParameterByName = function (name, url) {
    if (!name) return
    if (!url) url = window.location.href
    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const scrollToElementId = function (id, duration, margin) {
    // if no element scroll to top
    var element = document.getElementById(id)
    if (!element) element = document.documentElement || document.body

    var margin = margin
    if (!margin) margin = 0

    function animate (callback, duration, easing) {
        if (!duration) duration = 300
        if (!easing) easing = function (t) { return t }
        var start = (new Date()).getTime()
        var animation = function () {
            var t = easing(((new Date()).getTime() - start) / duration)
            t <= 1 ? requestAnimationFrame(animation) : t = 1
            callback(t, t === 1)
        }
        animation()
    }

    if (!duration) duration = 300

    var current = document.documentElement.scrollTop || document.body.scrollTop
    var target = element.getBoundingClientRect().top - 60 - margin
    animate(function (t, done) {
        window.scrollTo(0, current + target * t)
    }, duration, function (t) { return (--t) * t * t + 1 })
}

export const getMobileOperatingSystem = function () {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }

  return 'unknown'
  // return “Android” - one should either handle the unknown or fallback to a specific platform, let’s say Android
}
